<template>
    <div class="media-view">

        <div class="cast-view body-item">
            <div class="title t-1"></div>

            <div class="view m-cast">
            
                <div class="m-air">
                    <div class="air-view">
                        <div class="air-cast" v-if="live_data.state"><iframe v-bind:src="live_data.url" frameborder="0" width="100%" height="100%"></iframe></div>
                        <div class="air-cover" v-else><img v-bind:src="live_data.cover"></div>                  
                    </div>
                </div>

                <div class="video-list">
                    <vuescroll :ops="ops">
                    <div class="list" v-if="ready">
                        <div class="video-item" v-for="(item,index) in video_data" :key="index">
                            <div class="video-cover">
                                <a v-bind:href="item.url" target="_blank">
                                    <img v-bind:src="item.coverUrl" v-bind:alt="item.title" srcset="">
                                </a>                               
                            </div>
                            <p><a v-bind:href="item.url" target="_blank">{{ item.title }}</a></p>
                        </div>                   
                    </div>
                    </vuescroll>                  
                </div>             

            </div>
        </div>


        <div class="news-view body-item">
            <div class="title t-2"></div>
            <div class="view">
                <div class="m-news">
                    <vuescroll :ops="ops">
                    <ul>
                        <li v-for="(item,index) in  news_data" :key="index">
                            <a v-bind:href="item.url" target="_blank" rel="noopener noreferrer">{{ item.title }}</a>
                            <span class="time">{{ item.date }}</span>
                        </li>
                    </ul>
                    </vuescroll>
                </div>

                <div class="air-swiper">
                    <div class="air-wrapper">
                        <el-carousel height="330px" trigger="click" :autoplay="true" :interval="3000">
                            <el-carousel-item v-for="(item,index) in banner_data" :key="index">
                                <div class="img"><img v-bind:src="item.coverUrl" alt=""></div>
                                <a v-bind:href="item.url" target="_blank" rel="noopener noreferrer"></a>
                            </el-carousel-item>
                        </el-carousel>   
                    </div>          
                </div>
            </div>
        </div>

      
    </div>
</template>

<style scoped>

    .media-view{
        width: 100%;
        /* height: 1659px; */
        height: 1463px;
        margin: 0 auto;
        padding-top: 40px;
        background-image: url(~@/assets/images/bg-cast.jpg); 
        background-position: center;
        background-repeat: no-repeat;
        box-sizing: border-box;  
    }

    .view.m-cast{
        width: 1401px;
        margin: 0 auto 140px;
    }

    .title.t-1{
        width: 1113px;
        height: 170px;
        margin: 0 auto;
        background-image: url(~@/assets/images/title-3.png);
    }

    .title.t-2{
        width: 1113px;
        height: 170px;
        margin: 0 auto 55px;
        background-image: url(~@/assets/images/title-4.png);
    }    


    .view{
        display: flex;
        justify-content: space-between;
        width: 1401px;
        margin: 0 auto;
    }

    .m-air{
        position: relative;
        width: 770px;
        height: 433px;
        background-image: url(../assets/images/bg-air-view.png);
    }

    .m-air .air-view{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 751px;
        height: 416px;
        transform: translate(-50%,-50%);       
    }

    .m-air .air-cast,
    .m-air .air-cover{
        width: 100%;
        height: 100%;
        padding: 2px;
        box-sizing: border-box;
    }

    .m-air .air-cover img{
        width: 100%;
        height: 100%;
    }

    .air-swiper{
        width: 660px;
        height: 330px;
        /* background-color: #b28850; */
        overflow: hidden;
        border: 1px solid #b28850;   
    }

    .air-swiper .img{
        width: 100%;
        height: 100%;
    }

    /* .air-swiper .air-wrapper{
        width: 100%;
        height: 449px;
        padding: 1px;
        overflow: hidden;
        box-sizing: border-box;        
    } */

    .air-swiper a{
        position: absolute;
        left: 0;
        top: 0;
        display: block;
        width: 100%;
        height: 100%;
    }

    .video-list{
        width: 616px;
        height: 434px;     
    }

    .video-list .list{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding-right: 20px;
    }

    .video-list .video-item{
        margin-bottom: 18px;
    }

    .video-cover{
        position: relative;
        width: 287px;
        height: 161px;
        background-color: #b28850;
    }

    .video-cover::after{
        position: absolute;
        display: block;
        content: '';
        left: 50%;
        top: 50%;
        width: 61px;
        height: 65px;
        transform: translate(-50%,-50%);
        background-image: url(~@/assets/images/btn-play.png);
        z-index: 5;
        pointer-events: none;
    }

    .video-cover a{
        position: absolute;
        display: block;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 4;
    }

    .video-cover img{
        width: 100%;
        height: 100%;
    }

    .video-list p{
        width: 287px;
        margin-top: 10px;
        padding: 0 2px;
        height: 38px;
        font-size: 14px;
        color: #b28850;
        word-break: break-all;
        box-sizing: border-box;
    }

    .video-list a{
        color: #b28850;
        text-decoration: none;
    }

    .m-news{
        width: 701px;
        height: 330px;
        box-sizing: border-box;
        overflow-y: hidden;
    }
    
    .m-news li{
        line-height: 2.2;
        margin-bottom: 5px;
        margin-right: 18px;
        font-family: 'pageFont_SYH';
        font-size: 14px;
        color: #cf9f60;        
        border-bottom: .5px solid #83653c;
        overflow: hidden;
    }

    .m-news li a{
        display: inline-block;
        font-size: 14px;
        color: #cf9f60;
        text-decoration: none;
        transition: .3s all ease-in;
        max-width: 590px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            vertical-align: bottom;        
    }

    .m-news li a:hover{
        color: #eedac1;
    }

    .m-news li .time{
        float: right;
    }

</style>

<style>
    .air-swiper .el-carousel__button {
        display: block;
        opacity: .48;
        width: 14px;
        height: 14px;
        background-color: transparent;
        border: 1px solid #e3c195;
        outline: 0;
        padding: 0;
        margin: 0;
        cursor: pointer;
        -webkit-transition: .3s;
        transition: .3s;
        border-radius: 50%;
        box-sizing: border-box;
    }

    .el-carousel__indicator.is-active button{
        background-color: #e3c195;
    }

    .air-swiper .el-carousel__indicators--horizontal{
        bottom: 20px;
    }

    .el-carousel__indicator--horizontal{
        padding: 12px 5px;
    }
</style>

<script>
import vuescroll from 'vuescroll';

export default {
    components: {
        vuescroll,
    },      
    data() {
        return {
            banner_data : [],
            ad_data : [
                {
                    link : 'https://mall.jd.com/index-10517921.html',
                    img : require("../assets/images/ad/1.jpg"),
                },
                {
                    link : 'http://m6z.cn/5uUeOi',
                    img : require("../assets/images/ad/2.jpg"),
                },
                {
                    link : 'https://a21fs.tmall.com/p/rd955674.htm',
                    img : require("../assets/images/ad/3.jpg"),
                },
                {
                    link : 'https://victorage.tmall.com/ ',
                    img : require("../assets/images/ad/4.jpg"),
                },
                {
                    link : 'https://rijiaman.tmall.com/',
                    img : require("../assets/images/ad/5.jpg"),
                },                                                               
            ],
            video_data : [],
            live_data :{
                cover : '',
                url : '',
                state : false,
            },
            news_data : [],
            ops: {
                rail: {
                    opacity: 1,
                    background : '#000',
                },
                bar: {
                    background: '#b28850',
                    keepShow : true,
                }
            },             
            swiperOption: {
                slidesPerView: 4,
                spaceBetween: 30,
                slidesPerGroup: 4,
                loop: true,
                loopFillGroupWithBlank: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },
            ready : false,                         
        }
    },      
    created (){
        this.air_render();
        this.video_render();
        this.news_render();
        this.banner_render();
    },
    computed: {
        swiper() {
            return this.$refs.interSwiper.swiper
        }
    },
    watch: {
        video_data: function (newValue, oldValue) {
            this.ready = true;
        }
    },    
    methods : {
        video_render (){
            this.$axios.get(this.$ajax_url_map.videolist)
            .then(res => {
                this.ready = true;
                if(res.data.code == this.$ajax_code.success){
                    for(var i = 0;i < res.data.data.length;i++){
                        this.video_data.push(res.data.data[i]);
                    }
                }
                else{
                    this.$message.error('视频列表模块：数据请求失败，请稍后再试');
                }
            })
        },
        swiperNext() {
            this.$refs.interSwiper.$swiper.slideNext()
        },
        swiperPrev() {
            this.$refs.interSwiper.$swiper.slidePrev()
        },
        air_render (){
            this.$axios.get(this.$ajax_url_map.onair)
            .then(res => {
                if(res.data.code == this.$ajax_code.success){
                    let state = res.data.data.state;
                    this.live_data.state = state;
                    this.live_data.cover = res.data.data.coverUrl;
                    this.live_data.url = res.data.data.url;
                }
                else{
                    this.$message.error('直播模块：数据请求失败，请稍后再试');
                }
            })
        },
        news_render (){
            this.$axios.get(this.$ajax_url_map.news)
            .then(res => {
                //this.ready = true;
                if(res.data.code == this.$ajax_code.success){
                    for(var i = 0;i < res.data.data.length;i++){
                        this.news_data.push(res.data.data[i]);
                    }
                }
                else{
                    this.$message.error('新闻列表模块：数据请求失败，请稍后再试');
                }
            })
        },
        banner_render (){
            this.$axios.get(this.$ajax_url_map.banner)
            .then(res => {
                //this.ready = true;
                if(res.data.code == this.$ajax_code.success){
                    for(var i = 0;i < res.data.data.length;i++){
                        this.banner_data.push(res.data.data[i]);
                    }
                }
                else{
                    this.$message.error('轮播列表模块：数据请求失败，请稍后再试');
                }
            })
        },                
    },
}
</script>


// WEBPACK FOOTER //
// src/components/media.vue